import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity,  Dimensions, Image } from 'react-native';
import Grid from '@material-ui/core/Grid';

// const { width, height } = Dimensions.get('window');
const width = 480;
const _width = window.innerWidth

const  ExamsComponent = ({item, index, navigation}) => {
  const { imageUrl } = item;  
   return(
    <Grid  key={index} item xs={4}>
       <TouchableOpacity
          style={{}}
          onPress = {()=>{           
              navigation.push(`/courses/${item.id}`, {
                 examId: item.id
             })
          }
          }
          activeOpacity={.9}
          key={index}
       >
            <View style={styles.main}>
                <View style={styles.imageContainer}>
                    <Image style={styles.imageIcon} 
                   source={{uri:item.imageUrl}}
                    resizeMode='cover'
                    />
                    <View style={{justifyContent: 'center', alignItems: 'center'}}>
                        <Text ellipsizeMode='tail' numberOfLines={2} style={{fontSize: 16, fontWeight: '600', marginTop: 2, textTransform: 'uppercase'}}>{item.exam_name}</Text>
                    </View>
                </View>
            </View>
        </TouchableOpacity>
  
    </Grid>
   )
}

export default  ExamsComponent;
const styles = StyleSheet.create({
    main:{
        marginTop:10,
        height: 180,
        width:_width <= 780  ? Math.floor(_width - 40) : Math.floor(width/2 - 30),
        borderRadius:10,
        borderWidth: 4,
        borderColor: "#fff",
        marginHorizontal: 10,
        overflow: 'hidden'
    },
    imageContainer:{
        flex: 1,
        // justifyContent: 'center',
        // alignItems:'center'
    },
    imageIcon:{
        width:_width <= 780  ? '100%' : Math.floor(width/2 - 18),
        // borderRadius: 10,
        height:'80%'
    }

})